import { QueryClient } from '@tanstack/react-query';

export function invalidateEntity(queryClient: QueryClient, entityKey: string): void {
  queryClient.invalidateQueries({ queryKey: [entityKey] });
}

export function invalidateEntityDetail(
  queryClient: QueryClient,
  entityKey: string,
  id: string | number
): void {
  queryClient.invalidateQueries({ queryKey: [entityKey, 'detail', id] });
}
